export class AuthLoginModel{

      client_id:string;
      client_secret:string;
      username:string;
      password:string;
      grant_type:string;
      is_twitter_digit_auth:string;



}